import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const LICENSE_USAGE_REPORTS_LICENSE_USAGE_REPORT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/license-usage-reports',
        iconClass: 'fas fa-file-invoice',
        name: '::Menu:LicenseUsageReports',
        layout: eLayoutType.application,
        requiredPolicy: 'Ldm.LicenseUsageReport',
      },
    ]);
  };
}
